const queryStringArray = (name: string, array: any[]) => {
  if (!array || array.length === 0) {
    return ``;
  }
  let toReturn = '';
  array.forEach((val) => {
    toReturn += `${name}=${val}&`;
  });
  return toReturn;
};

export const ControllerRoutes = {
  Util: {
    UsersInRole: '/UsersInRole',
    selectOption: {
      enumType: (type: string) => `/selectOption/enum/${type}`,
      authorizedVets: `/selectOption/authorizedVets`
    }
  },
  Drug: {
    Select: '/Drug/Select'
  },
  Unit: {
    Base: '/Unit',
    Select: '/Unit/Select'
  },

  ProductRequest: {
    Base: '/ProductRequest'
  },
  ProductListing: {
    Base: '/ProductListing',
    calculatePrice: (
      drugFormId: number,
      strengthId: number,
      quantity: number,
      deliveryType?: number,
      deliveryCity?: string
    ) => {
      let url = `/ProductListing/calculate-price?drugFormId=${drugFormId}&strengthId=${strengthId}&quantity=${quantity}`;
      if (deliveryType != null) {
        url += `&deliveryType=${deliveryType}`;
      }
      if (deliveryCity) {
        url += `&deliveryCity=${encodeURIComponent(deliveryCity)}`;
      }
      return url;
    }
  },
  ProductForm: {
    Base: '/ProductForm',
    Select: '/ProductForm/Select'
  },
  Companies: {
    Base: '/Company'
  },
  Flavor: {
    Select: '/Flavor/Select'
  },
  Usage: {
    Select: '/Usage/Select'
  },
  order: {
    place: '/order',
    items: (itemIds: number[]) => `/order/items/?${queryStringArray('itemIds', itemIds)}`
  },
  ProductAdmin: {
    Unit: {
      Base: '/ProductAdmin/StrengthUnit',
      Select: '/ProductAdmin/StrengthUnit/Select'
    },
    Form: {
      Base: '/ProductAdmin/Form',
      Select: '/ProductAdmin/Form/Select'
    },
    Flavor: {
      Base: '/ProductAdmin/Flavor',
      Select: '/ProductAdmin/Flavor/Select'
    },
    Usage: {
      Base: '/ProductAdmin/Usage',
      Select: '/ProductAdmin/Usage/Select'
    },
    MarkupTemplate: {
      Base: '/ProductAdmin/MarkupTemplate',
      Select: '/ProductAdmin/MarkupTemplate/Select'
    },
    PricingSettings: '/ProductAdmin/PricingSettings',
    Drugs: '/ProductAdmin/Drug'
  },
  productManagement: {
    post: '/ProductManagement',
    put: (drugId: number) => `/ProductManagement/${drugId}`,
    forms: {
      post: (drugId: number, formId: number, markupTemplateId: number) =>
        `/productmanagement/${drugId}/forms/${formId}?markupTemplateId=${markupTemplateId}`,
      delete: (drugId: number, formId: number) => `/productmanagement/${drugId}/forms/${formId}`,
      put: (drugId: number, formId: number) => `/productmanagement/${drugId}/forms/${formId}`
    }
  }
};
